/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { forOwn } from "utils/lodashUtils";

export const decodeObjectValues = encodedValuesObject => {
  forOwn(encodedValuesObject, (value, key) => {
    encodedValuesObject[key] = decodeURIComponent(value);
  });
  return encodedValuesObject;
};

export const normalizeObjectValues = (obj, baseValue) => {
  const finalValues = {};
  for (const key in obj) {
    if (isNaN(obj[key])) finalValues[key] = normalizeObjectValues(obj[key], baseValue);
    else {
      const newValue = obj[key] - baseValue;
      finalValues[key] = newValue >= 0 ? newValue : obj[key];
    }
  }
  return finalValues;
};

export const isEmptyObject = value => value && value.constructor === Object && Object.keys(value).length === 0;
